import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Skeleton } from "antd";
import { useRouter } from "next/router";
import { H3, SharedLayout, StandardWidth, useTranslation } from ".";
export const DummyPage = ({ children }) => {
    const { t } = useTranslation("common");
    return (_jsx(SharedLayout, { query: {
            fetching: true,
            data: undefined,
            error: undefined,
            stale: false,
        }, title: t("redirect"), children: children }));
};
export const Redirect = ({ href, as, layout }) => {
    const router = useRouter();
    const { t } = useTranslation("common");
    useEffect(() => {
        router.push(href, as);
    }, [router, as, href]);
    if (layout) {
        return (_jsx(DummyPage, { children: _jsx(Skeleton, {}) }));
    }
    else {
        return (_jsxs(StandardWidth, { children: [_jsx(H3, { children: t("redirect") }), _jsx(Skeleton, {})] }));
    }
};
//# sourceMappingURL=Redirect.js.map